<template>
 <v-app 
    id="inspire"
    style="overflow: hidden"
  >
  <v-app-bar app>
    <v-toolbar-title class="flex text-center">
      Draw with Circles!
    </v-toolbar-title>
  </v-app-bar>
  <v-main background-color="#e0e0e0">
    
  <v-row class="root pa-5 ma-0">
    <v-col class="split left" cols="12" md="6">
      <div class="pa-5 cards" height="100%">
        <div class="prompt pa-2">Paste the data output from your code:</div>
        <v-textarea
          outlined 
          v-model="inputString" 
          color="teal" 
          rows="20"
          :background-color="bgcol"
          placeholder="{ ... }"
        >
        </v-textarea>
          <v-alert
            v-if="values.length==0 && inputString != ''"
            type="error"
          >
          Invalid data.
          </v-alert>
          <v-row 
            align="center"
            justify="space-around"  
            class="examples"
          >
            <v-btn class="ma-2" @click="clickExample('babyyoda')">
              Baby Yoda
            </v-btn>
            <v-btn class="ma-2" @click="clickExample('ellipse')">
              Ellipse
            </v-btn>
            <v-btn class="ma-2" @click="clickExample('spiral')">
              Spiral
            </v-btn>
            <v-btn class="ma-2" @click="clickExample('pi')">
              Pi
            </v-btn>
            <v-btn class="ma-2" @click="clickExample('batman')">
              Batman
            </v-btn>

          </v-row>
      </div>
    </v-col>

    <v-col class="split right" cols="12" md="6">
      <div class="cards cright">
        <div
          class="controlbox pa-10 pt-2"
        >
            <v-slider
              v-if="values.length>0"
              v-model="framerate"
              label="Framerate"
              :max="60"
              ticks="always"
              height="20px"
              class="slider"
            />
            <v-checkbox
              v-if="values.length>0"
              label="Smooth"
              v-model="smoothCurve"
            >

            </v-checkbox>
        </div>
        
        <Epicircles
          v-if="values.length>0"
          :fourier="values"
          :size="512"
          :framerate="framerate"
          :smooth="smoothCurve"
        />
        <div
          v-if="values.length==0"
          class="pt-1"
        >
          <v-alert
              type="info"
              class="ma-10"
            >
            Enter the values from your exercise in the text area.
          </v-alert>
        </div>
      </div>

    </v-col>
  </v-row>
  </v-main>
 </v-app>
</template>

<script>
import Epicircles from "@/components/Epicircles";
import examples from '@/examples.js'

export default {
  name: "Home",
  components: {
    Epicircles
  },
  data: () => ({
    inputString: "",
    bgcol: "#f0f0f0",
    framerate: 20,
    smoothCurve: true,
  }), 
  computed: {
    values() {
      if (this.inputString == '') return [];
      try {
        let res =  JSON.parse(this.inputString);
        if (res && res.length > 0) {
          return res;
        } else {
          return []
        }
      } catch (err) {
        return []
      }
    }
  },
  methods: {
    clickExample(name) {
      this.inputString = examples[name];
    },
  },
};
</script>

<style lang="scss" scoped>
.split {
  padding: 0;
  margin: 0;
  padding: 1em;
}
.userresults {
  margin-right: 0px;
}
.v-text-field {
  font-family:monospace;
}
.prompt {
  font-size: 15pt;
}
.v-app-bar {
  text-align: center;
}

.v-main {
  height: 100%;
  background-color: #e0e0e0;
}
.right {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}
.cright {
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.cards {
  background-color: white;
  box-shadow: 1px 1px 1px 1px rgb(213, 213, 213);
  border-radius: 10px;
  height: 100%;
  width: 100%;
}

.examples {
  display: flex;
  justify-content: center;
  .v-btn {
    margin: 0em 1em
  }
}

.controlbox {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.slider {
  padding-top: 1em;
  padding-right:1em;
  align-items: center;
  justify-content: center
}

</style>